<template>
  <div class="spl-parcel-detail-block-log">
    <div class="spl-parcel-detail-block-log__label">
      {{ label }}
    </div>
    <div :class="{'spl-parcel-detail-block-log__body-expanded': expandList}" class="spl-parcel-detail-block-log__body">
      <div class="spl-parcel-detail-block-log__body__header">
        <div class="spl-parcel-detail-block-log__body__header__column">
          Action
        </div>
        <div class="spl-parcel-detail-block-log__body__header__column">
          Time
        </div>
        <div class="spl-parcel-detail-block-log__body__header__column">
          User
        </div>
        <div class="spl-parcel-detail-block-log__body__header__column">
          Note
        </div>
      </div>
      <div
        v-for="(item, index) in content"
        :key="'parcelDetailLogContent' + index"
        :class="{'spl-parcel-detail-block-log__body__row-red': item.error}"
        class="spl-parcel-detail-block-log__body__row">
        <div
          v-for="(column, columnIndex) in item.columns"
          :key="'parcelDetailLogColumn' + columnIndex"
          class="spl-parcel-detail-block-log__body__row__column">
          {{ column }}
        </div>
      </div>
    </div>
    <div
      v-if="content.length > 8"
      class="spl-parcel-detail-block-log__expand-list"
      @click="toggleList">
      {{ expandListLabel }}
    </div>
  </div>
</template>

<script>
import Helpers from '@/helpers'
export default {
  name: 'ParcelDetailBlockLogLog',
  mixins: [Helpers],
  props: [
    'label',
    'content'
  ],
  data () {
    return {
      expandList: false
    }
  },
  computed: {
    expandListLabel () {
      return this.expandList ? 'Contract list' : 'Expand list'
    }
  },
  methods: {
    toggleList () {
      this.expandList = !this.expandList
    }
  }
}
</script>

<style lang="scss">
    @import '../../variables.scss';

    .spl-parcel-detail-block-log {
        background-color: $parcelTimelineBackgroundColor;
        margin-bottom: 20px;
        padding: 20px 17px 30px 17px;
        position: relative;
        width: 100%;

        &__label {
            color: $mainInputColor;
            font-size: 18px;
            font-weight: 600;
            margin-bottom: 5px;
        }
        &__body {
            max-height: 234px;
            margin: 0 -17px;
            overflow: hidden;

            @include mobile() {
                overflow-x: auto;
            }
            &-expanded {
                max-height: none;
            }
            &__header,
            &__row {
                @include mobile() {
                    min-width: 550px;
                }
                &:after {
                    clear: both;
                    content: '';
                    display: block;
                    float: none;
                }
                &__column {
                    font-size: 12px;
                    float: left;
                    line-height: 26px;
                    padding-left: 17px;
                    width: 25%;
                }
            }
            &__header {
                &__column {
                    font-size: 14px;
                    font-weight: 600;
                }
            }
            &__row-red {
                color: $red;
            }
            &__row:nth-child(even) {
                background-color: $parcelDetailBlockLogRowColor;
            }
        }
        &__expand-list {
            color: $disabledYellow;
            cursor: pointer;
            font-size: 12px;
            font-weight: 600;
            margin-top: 15px;
            transition: color $shortTransition ease-in-out;

            &:hover {
                color: $mainInputColor;
            }
        }
    }
</style>
